import Phone from "~icons/ph/phone";
import type { AuthenticatedSnapshot } from "../../shared/types";
import { t } from "../i18n";
import { HistoryRow } from "./person-row";

export function HistoryScreen({
  account: { history },
}: {
  account: AuthenticatedSnapshot;
}) {
  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="app-screen"
      aria-label={t("سجل المكالمات")}
    >
      <h1 id="calls-title">{t("سجل المكالمات")}</h1>
      {history.length ? (
        history.map((h) => <HistoryRow key={h.id} call={h} />)
      ) : (
        <div className="inline-empty screen-empty">
          <Phone width={32} height={32} aria-hidden="true" />
          <p>{t("ستظهر مكالماتك هنا.")}</p>
        </div>
      )}
    </main>
  );
}
